module.exports = __webpack_public_path__ + "img/table-join.07918c4a.svg";